// Shared label-formatting for the Demo Env Mgmt entity hierarchy (Account -> Project ->
// Datasource) and for User, which has no label of its own — see users-section.js.

// A user has no label of its own; its display label is the label of the account it's linked to
// (users hold the required FK to account — see demo-env-user.entity.ts).
export function formatUserLabel(user) {
  if (!user) return '';
  return user.account ? `${user.account.label} (${user.email})` : user.email;
}

// [AccountLabel] ProjectLabel
export function formatProjectLabel(project) {
  if (!project) return '';
  const prefix = project.account ? `[${project.account.label}] ` : '';
  return `${prefix}${project.label}`;
}

// [AccountLabel][ProjectLabel] DatasourceLabel
export function formatDatasourceLabel(datasource) {
  if (!datasource) return '';
  const project = datasource.project;
  const accountPrefix = project?.account ? `[${project.account.label}]` : '';
  const projectPrefix = project ? `[${project.label}]` : '';
  const prefix = accountPrefix || projectPrefix ? `${accountPrefix}${projectPrefix} ` : '';
  return `${prefix}${datasource.label}`;
}
